'use client';

import { cn } from '@/lib/utils';
import { MethodBadge } from './method-badge';
import type { ProviderEndpoint } from '@/lib/integrations/types';

interface EndpointListItemProps {
  endpoint: ProviderEndpoint;
  selected?: boolean;
  onClick: () => void;
}

export function EndpointListItem({ endpoint, selected, onClick }: EndpointListItemProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'w-full text-left px-3 py-2 rounded-md transition-colors',
        'hover:bg-accent hover:text-accent-foreground',
        'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1',
        selected && 'bg-accent text-accent-foreground'
      )}
    >
      <div className="flex items-start gap-2">
        <MethodBadge method={endpoint.method} size="sm" className="mt-0.5 shrink-0" />
        <div className="min-w-0 flex-1">
          <div className="font-mono text-sm truncate">{endpoint.path}</div>
          {endpoint.description && (
            <div className="text-xs text-muted-foreground truncate mt-0.5">
              {endpoint.description}
            </div>
          )}
        </div>
      </div>
    </button>
  );
}

export default EndpointListItem;
